import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import theme from 'live/services/theme'
import FormGroup from 'live/components/forms/ui/form-group'

import { canCreateCompanies } from './../permissions/index'
import CompanyList from './CompanyList'

const ListPanel = ({ companies, selectCompany, companySelected, handleCreateCompany, deleteCompany, showDeleteCompany }) => {
    const [companiesToShow, setCompanies] = useState(companies)

    useEffect(() => {
        setCompanies(companies)
    }, [companies])
    function filterCompanies(value) {
        if (companies) {
            const arrCompany = companies.filter(company => company.name.toLowerCase().includes(value.toLowerCase()))
            setCompanies(value ? arrCompany : companies)
        }
    }
    return (
        <LPanel>
            <PanelHeader handleCreateCompany={handleCreateCompany} filterCompanies={filterCompanies} />
            <CompanyList showDeleteCompany={showDeleteCompany} companies={companiesToShow} selecteCompany={selectCompany} companySelected={companySelected} deleteCompany={deleteCompany} />
        </LPanel>
    )
}

export default ListPanel;

const LPanel = styled.div`
      
      overflow-y: auto;
      background-color:white;
      width: 300px;
      border: 1px solid rgb(221, 222, 225);

      
`

const PanelHeader = ({ handleCreateCompany, filterCompanies }) => {
    const [enableSearch, setEnableSearch] = useState(false)

    function handleClick() {
        if (enableSearch) {
            setEnableSearch(false)
            filterCompanies("")
        } else {
            setEnableSearch(true)
        }
    }

    return (
        <HeaderDiv className="add-company-button">

            {canCreateCompanies() && !enableSearch ?
                <div className="add-company" onClick={handleCreateCompany}>
                    <i class="far fa-plus-circle" />
                    <span>New Company</span>
                </div>
                : null}
            {enableSearch &&
                <div className="search-input ">
                    <input autoFocus id={"searchCompany"}onChange={(evt) => filterCompanies(evt.target.value)} placeholder={"Type to search"} />
                </div>
            }
            <div className="search-button">

                <i className={enableSearch ? "fas fa-times" : "far fa-search"} onClick={handleClick} />
            </div>

        </HeaderDiv>
    )

}

const HeaderDiv = styled.div`

        display:flex;
        height:44px;
        background-color:#eeeeee;
        color:#37a3ef;
        font-size: 14px;
        border-bottom: 1px solid rgb(221, 222, 225);


        align-items:center;

        .add-company{

            font-weight: 300;
            width:100%;
            flex: 1 1 auto;

            i {
            margin-right:15px;
            padding:10px; 
                 
            }

            :hover{
                cursor:pointer;
                font-weight:900;  
                i{
                    font-weight:900; 
                }
            }      


        }

        .search-input{
            font-weight: 300;
            width:100%;
            /* flex: 1 1 auto; */
            height:44px;
            border-bottom: 1px solid rgb(221, 222, 225);
            overflow:hidden;

            input{
                flex: 1;
                border: 0;
                outline: 0;
                font-size: 14px;
                padding: 14px;
                width:100%;
                color: black;
            }
        }
        
        .search-button{
            width:56px;
            display:flex;
            color: rgb(96, 106, 128);
            align-items:center;
            justify-content:center;
            border-left: 1px solid rgb(221, 222, 225);
            height:100%;

            
            :hover{
                cursor:pointer;
                i{
                font-weight:900; 
                }
            }
            
        }


`




